import { Component } from '@angular/core';
import { DetailedLoadingIndicatorComponent } from '../../../components/detailed-loading-indicator/detailed-loading-indicator.component';

@Component({
  selector: 'td-wb-learn-loading',
  templateUrl: 'learn-loading.component.html',
  styleUrls: ['learn-loading.component.scss'],
  imports: [
    DetailedLoadingIndicatorComponent
  ]
})
export class LearnLoadingComponent {
}

